export default "__VITE_ASSET__zfYzyWSl__"